import clsx from 'clsx';
import { FC } from 'react';
import styles from './Spinner.module.css';

export interface SpinnerProps {
  className?: string;
}

export const Spinner: FC<SpinnerProps> = ({ className }) => (
  <div className={clsx(styles.spinner, className)} data-testid="spinner" />
);
